module.exports = __webpack_public_path__ + "media/images/countrysquared/kg-9bf6ddff13f728d6e8a30c3eee413d80.svg";